module.exports = "<div class=\"draggable-image-area\" [class.drop-state]=\"dropStateActive\">\n  <ng-content></ng-content>\n\n  <div class=\"drag-overlay\">\n    <b>Drop image</b>\n  </div>\n</div>\n\n<input #imageUpload accept=\".png,.gif,.jpg,.jpeg\" type=\"file\" id=\"image-upload-input\" (change)=\"imageSelected($event)\">\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/draggable-image-wrapper/draggable-image-wrapper.component.html
// module id = ../../../../../src/app/shared/components/draggable-image-wrapper/draggable-image-wrapper.component.html
// module chunks = 12